import React, {memo, useState, useCallback} from "react";
import PropTypes from "prop-types";
import {useRegScoutCore} from "../../../resources/RegScoutCoreProvider";
import {NavLink} from "react-router-dom";
import {Chip, Link, Tooltip} from "@mui/material";
import {riskScoreDefinition} from "../../../resources/environment";
import {map} from "underscore";

const stopPropagation = (event) => event.stopPropagation();

const transitionProps = {
  sx: {backgroundColor: "rgba(97, 97, 97, 0.98) !important"},
};

const LazyTooltipChip = memo(({title, chipProps}) => {
  const [hovered, setHovered] = useState(false);
  const onEnter = useCallback(() => setHovered(true), []);
  const onLeave = useCallback(() => setHovered(false), []);

  return hovered ?
    (
      <Tooltip
        title={title}
        open
        placement="bottom-start"
        onClick={stopPropagation}
        TransitionProps={transitionProps}
        onClose={onLeave}
      >
        <Chip {...chipProps} onMouseLeave={onLeave} />
      </Tooltip>
    ) :
    <Chip {...chipProps} onMouseEnter={onEnter} />;
});

const TagChips = memo(({chips, disableHover = false}) => {
  const {isProfessional, needsUpgrade} = useRegScoutCore();

  const upgradeLabel = "Upgrade for Risk Score";
  const upgradeLink = (
    <Link component={NavLink} to="/pricing" target="_blank">
      here
    </Link>
  );
  const upgradeMessage =
    isProfessional ?
      (
        <>
          Click
          {upgradeLink}
          {" "}
          to upgrade and see exact scores.
        </>
      ) :
      (
        <>
          Click
          {upgradeLink}
          {" "}
          to upgrade.
        </>
      );
  const upgradeTooltip = (
    <>
      {riskScoreDefinition}
      <br />
      <br />
      {upgradeMessage}
    </>
  );

  return map(chips, (tag, index) => {
    const {color, fill, label, tooltip, type} = tag;
    const upgradeRequired = needsUpgrade && type === "risk";
    const title =
      disableHover ?
        "" :
        upgradeRequired || (isProfessional && type === "risk") ?
          upgradeTooltip :
          tooltip;
    const chipProps = {
      label: upgradeRequired ? upgradeLabel : label,
      color: upgradeRequired ? "default" : color,
      variant: "filled",
      clickable: false,
      component: "span",
      onClick: stopPropagation,
      sx: {
        backgroundColor: upgradeRequired ? undefined : fill,
        color: upgradeRequired ? undefined : "primary.contrastText",
        cursor: "default",
      },
    };

    return <LazyTooltipChip key={index} title={title} chipProps={chipProps} />;
  });
});

TagChips.propTypes = {
  chips: PropTypes.array,
  disableHover: PropTypes.bool,
};

export default TagChips;
